export enum ENVIRONMENTS {
  LOCALHOST = 'localhost',
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export const getEnvFromHostname = (): ENVIRONMENTS => {
  const { hostname } = window.location;

  if (/lightspeedapp(?:staging|stg)/.test(hostname)) {
    return ENVIRONMENTS.STAGING;
  }

  if (/merchantos|lightspeedapp/.test(hostname)) {
    return ENVIRONMENTS.PRODUCTION;
  }

  return ENVIRONMENTS.DEVELOPMENT;
};

window.getEnvFromHostname = getEnvFromHostname;
